import { isIOS, isAndroid } from 'react-device-detect';

export default { isIOS, isAndroid };
